import React, { useState } from "react";
import { Row, Col, Table, Space, Button, Typography } from "antd";
import c from "../utils/common";
import metaData from "../data/metaData";
import log from "../utils/log";

//
import Meta from "./Meta";
import ActionHeader from "./Table/ActionHeader";
import CheckBox from "./General/Checkbox";
import ProductPeriod from "./Table/ProductPeriod";
import ProductTag from "./Table/ProductTag";

const { Text, Title } = Typography;

const ProductTable = ({
  data,
  loading,
  canAdd = false,
  canDelete = false,
  canSelect,
  onSelect,
  onAdd,
  onDelete,
  companyId,
  rowDisablePredicate = () => false,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [filteredDataCount, setFilteredDataCount] = useState(data.length);

  const getDisableMeta = (record) => {
    const result = rowDisablePredicate?.(record);
    log.debug(result);
    if (typeof result === "object") return result;
    return { disabled: false }; // fallback
  };

  const columns = [
    // {
    //   title: "Product ID",
    //   dataIndex: "id",
    //   key: "id",
    //   width: 150,
    // },
    {
      title: "Product",
      dataIndex: "name",
      key: "name",
      width: 350,
      render: (text, record) => {
        return (
          <Meta
            image={
              record?.gallery?.[0] ? (
                <img
                  style={{ width: 75, objectFit: "cover", marginRight: "0.5rem" }}
                  src={metaData.blobPreURL + "clientUpload-" + record.gallery[0] + ".jpeg" + metaData.blobPostURL}
                />
              ) : null
            }
            title={<Title level={5}>{record?.name}</Title>}
            description={<ProductTag product={record} />}
            maxWidth={200}
          />
        );
      },
      sorter: (a, b) => (a?.name).localeCompare(b?.name),
    },
    {
      title: "",
      dataIndex: "time",
      key: "time",
      width: 450,
      render: (text, record) => <ProductPeriod time={record?.time} />,
    },
    {
      title: "Available Qty",
      dataIndex: "qty",
      key: "qty",
      width: 150,
      render: (text, record) => {
        return <Text strong>{record?.qty?.available || 0}</Text>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        let { company, brand } = record || {};
        const { disabled, reason } = getDisableMeta(record);

        return disabled ? (
          reason
        ) : (
          <Space size="middle">
            {canDelete && company?.id !== companyId ? (
              <Button danger loading={loading} onClick={() => onDelete(record?.id)}>
                Remove
              </Button>
            ) : null}
            {canAdd ? (
              <Button type="primary" loading={loading} onClick={() => onAdd(record?.id)}>
                Add
              </Button>
            ) : null}
            {canSelect ? (
              <CheckBox
                checked={record?.selected}
                size="1.75rem"
                // onClick={(e) => {
                //   e.stopPropagation(); // Prevent the row click event from being triggered
                //   if (!disabled) onSelect(record?.id);
                // }}
              />
            ) : null}
          </Space>
        );
      },
    },
  ];

  const handleActionClick = (key) => {
    log.debug(key);
  };

  // Handle pagination change (page number or page size change)
  const handleTableChange = (pagination, filters, sorter, extra) => {
    const { current, pageSize } = pagination;
    setPagination(current);
    setFilteredDataCount(extra.currentDataSource.length);
  };

  return (
    <>
      <ActionHeader
        pagination={pagination}
        pageSize={5}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        count={filteredDataCount}
        onActionClick={handleActionClick}
      />

      <Table
        className="white-table-header"
        rowClassName={(record) => (rowDisablePredicate(record)?.disabled ? "disabled-table-row" : "")}
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination,
          pageSize: 5,
          position: ["none", "bottomCenter"],
          showSizeChanger: false,
        }}
        onRow={
          canSelect
            ? (record) => ({
                onClick: () => {
                  const { disabled, reason } = getDisableMeta(record);
                  if (!disabled) onSelect(record?.id);
                },
              })
            : undefined
        }
        onChange={handleTableChange} // Handles next/prev page
      />
    </>
  );
};

export default ProductTable;
